<template>
  <!-- 解决方案 -->
  <div>
    <div v-if="this.$route.path == '/pc/programme'">
      <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 解决方案轮播图 -->
    <ProgrammeBanner></ProgrammeBanner>
    <!-- 物联网智能硬件 -->
    <Hardware></Hardware>
    <!-- 行业解决方案 -->
    <Programme></Programme>
    <!-- 通用解决方案 -->
    <Currency></Currency>
    <!-- 底部导航 -->
    <BottomNav></BottomNav>
    </div>
    <div v-else>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../components/pc/components/TopNav.vue";
import BottomNav from "../../../components/pc/components/BottomNav.vue";
import ProgrammeBanner from "../../../components/pc/Programme/ProgrammeBanner.vue";
import Hardware from "../../../components/pc/Programme/Hardware.vue";
import Programme from "../../../components/pc/Programme/Programme.vue";
import Currency from '../../../components/pc/Programme/Currency.vue'

export default {
  setup() {
    return reactive({

    });
  },
  components: {
    TopNav,
    BottomNav,
    ProgrammeBanner,
    Hardware,
    Programme,
    Currency,
  },
};
</script>

<style scoped>
</style>
